// fr translations — extracted mechanically from LanguageContext.jsx (Team Foundation).
// Feature-specific keys belong in src/i18n/extensions/*.js instead.
const fr = {
    // Common
    "common.loading": "Chargement...",
    "common.save": "Enregistrer",
    "common.cancel": "Annuler",
    "common.delete": "Supprimer",
    "common.edit": "Modifier",
    "common.submit": "Soumettre",
    "common.back": "Retour",
    "common.next": "Suivant",
    "common.previous": "Précédent",
    "common.search": "Rechercher",
    "common.filter": "Filtrer",
    "common.all": "Tous",
    "common.yes": "Oui",
    "common.no": "Non",
    "common.logout": "Déconnexion",
    "common.login": "Connexion",
    "common.register": "S'inscrire",
    
    // Auth
    "auth.welcome": "Bienvenue",
    "auth.signIn": "Connectez-vous à votre compte",
    "auth.email": "E-mail",
    "auth.password": "Mot de passe",
    "auth.loginButton": "Se Connecter",
    "auth.noAccount": "Pas de compte? Inscrivez-vous avec un lien d'invitation.",
    "auth.loginSuccess": "Connexion réussie",
    "auth.loginFailed": "Échec de connexion",
    
    // Navigation
    "nav.dashboard": "Tableau de Bord",
    "nav.releases": "Sorties",
    "nav.payouts": "Paiements",
    "nav.support": "Support",
    "nav.analytics": "Statistiques",
    "nav.referrals": "Parrainages",
    "nav.subscription": "Abonnement",
    "nav.profile": "Profil",
    
    // Dashboard
    "dashboard.welcome": "Bienvenue",
    "dashboard.subtitle": "Gérez votre musique, suivez vos sorties et consultez vos revenus.",
    "dashboard.totalReleases": "Sorties Totales",
    "dashboard.totalTracks": "Pistes Totales",
    "dashboard.balance": "Solde Actuel",
    "dashboard.withdrawable": "Retirable",
    "dashboard.recentReleases": "Sorties Récentes",
    "dashboard.viewAll": "Voir Tout",
    "dashboard.newRelease": "Nouvelle Sortie",
    "dashboard.newReleaseDesc": "Partagez votre musique avec le monde",
    "dashboard.requestPayout": "Demander un Paiement",
    "dashboard.noReleases": "Pas encore de sorties",
    "dashboard.createFirst": "Créez votre première sortie pour commencer.",
    
    // Analytics
    "analytics.title": "Statistiques",
    "analytics.subtitle": "Suivez les performances de vos sorties",
    "analytics.totalStreams": "Écoutes Totales",
    "analytics.listeners": "Auditeurs",
    "analytics.estimatedEarnings": "Gains Estimés",
    "analytics.monthlyGrowth": "Croissance Mensuelle",
    "analytics.streamsChart": "Graphique des Écoutes",
    "analytics.platformDistribution": "Distribution par Plateforme",
    "analytics.topTracks": "Titres Populaires",
    "analytics.trackName": "Nom du Titre",
    "analytics.streams": "écoutes",
    "analytics.comingSoonTitle": "Très Bientôt",
    "analytics.comingSoonDesc": "Des analyses détaillées et des statistiques seront bientôt disponibles. Avec l'intégration artist.tools, vous pourrez suivre toutes vos données de plateformes en un seul endroit.",
    "common.comingSoon": "Bientôt",
    
    // Payouts
    "payouts.title": "Gérez Vos Revenus",
    "payouts.subtitle": "Retirez facilement vos revenus musicaux. Demandez un paiement à partir de 50$.",
    "payouts.fastPayment": "Paiement rapide",
    "payouts.secureTransfer": "Transfert sécurisé",
    "payouts.totalBalance": "Solde Total",
    "payouts.withdrawableBalance": "Disponible",
    "payouts.requestPayout": "Demander un Paiement",
    "payouts.payoutHistory": "Historique des Paiements",
    "payouts.noPayouts": "Pas encore de demandes de paiement",
    "payouts.noPaymentMethod": "Aucune Méthode de Paiement",
    "payouts.addMethodDesc": "Ajoutez une méthode de paiement pour retirer vos revenus.",
    "payouts.addMethod": "Ajouter une Méthode de Paiement",
    "payouts.changeMethodVerification": "Vérification par email requise pour modifier votre méthode de paiement actuelle",
    "payouts.availableBalance": "Solde Disponible",
    "payouts.pendingBalance": "Solde en Attente",
    "payouts.withdrawalHistory": "Historique des Retraits",
    "payouts.requestWithdrawal": "Demander un Retrait",
    "payouts.minWithdrawal": "Retrait minimum: 50$",
    "payouts.manageEarnings": "Gérez vos revenus",
    "payouts.createRequest": "Créer une Demande de Paiement",
    "payouts.amount": "Montant",
    "payouts.accountHolder": "Titulaire du Compte",
    "payouts.bankName": "Nom de la Banque",
    "payouts.minAmount": "Le montant minimum de retrait est de 50$",
    "payouts.insufficientBalance": "Solde insuffisant",
    "payouts.fillRequired": "Veuillez remplir tous les champs requis",
    "payouts.requestCreated": "Demande de paiement créée",
    "payouts.requestFailed": "Demande échouée",
    "payouts.minNotMet": "Minimum non atteint",
    "payouts.minNotMetMsg": "Vous avez besoin d'au moins 50$ de solde disponible pour demander un paiement.",
    "payouts.statusRequested": "Demandé",
    "payouts.statusPaid": "Payé",
    "payouts.paymentMethod": "Méthode de Paiement",
    "payouts.bankTransfer": "Virement Bancaire",
    "payouts.paypalEmail": "Email PayPal",
    "payouts.paypalNote": "Entrez l'adresse email associée à votre compte PayPal",
    "payouts.fillPaypalRequired": "Veuillez entrer l'email PayPal et le nom du titulaire",
    "payouts.selectCountry": "Sélectionnez votre pays",
    "payouts.tabProfile": "Profil de Paiement",
    "payouts.tabMethod": "Méthode de Paiement",
    "payouts.tabRequests": "Demandes de Retrait",
    "payouts.requirements": "Conditions pour le Retrait",
    "payouts.completeProfile": "Complétez votre profil de paiement (Identité et Adresse)",
    "payouts.addPaymentMethod": "Ajoutez une méthode de paiement (Banque ou PayPal)",
    "payouts.verifyPaymentMethod": "Vérifiez votre méthode de paiement",
    "payouts.profileComplete": "Complété",
    "payouts.savedProfile": "Informations de Profil Enregistrées",
    "payouts.fullName": "Nom Complet",
    "payouts.phoneNumber": "Téléphone",
    "payouts.location": "Emplacement",
    "payouts.profileType": "Type de Profil",
    "payouts.individual": "Individuel",
    "payouts.business": "Entreprise / Société",
    "payouts.edit": "Modifier",
    
    // Support
    "support.title": "Comment pouvons-nous vous aider?",
    "support.subtitle": "L'équipe EAM Music est là pour répondre à vos questions.",
    "support.responseTime": "Réponse sous 24 heures",
    "support.professional": "Support professionnel",
    
    // Referrals
    "referrals.title": "Programme de Parrainage",
    "referrals.subtitle": "Invitez vos amis sur EAM Music et gagnez 5% de commission.",
    "referrals.commission": "5% Commission",
    "referrals.lifetime": "Revenus à vie",
    
    // Statuses
    "status.draft": "Brouillon",
    "status.submitted": "Soumis",
    "status.inReview": "En Révision",
    "status.approved": "Approuvé",
    "status.rejected": "Rejeté",
    "status.live": "En Ligne",
    
    // Validation
    "validation.audioRequired": "Le fichier audio est obligatoire",
    "validation.audioFormatWav": "Le fichier audio doit être au format WAV ou FLAC",
    "validation.titleRequired": "Le titre est obligatoire",
    "validation.titleLanguageRequired": "La langue du titre est obligatoire",
    "validation.primaryArtistRequired": "Au moins un artiste principal est requis",
    "validation.primaryGenreRequired": "La sélection du genre principal est obligatoire",
    "validation.explicitRequired": "La sélection du type de contenu est obligatoire",
    "validation.coverRequired": "L'image de couverture est obligatoire",
    "validation.songwriterRequired": "Au moins un auteur-compositeur est requis",
    "validation.contributorRequired": "Au moins un contributeur est requis",
    "validation.productionTeamRequired": "Au moins un membre de l'équipe de production est requis",
    "validation.platformRequired": "Au moins une plateforme doit être sélectionnée",
    "validation.releaseDateRequired": "La date de sortie est obligatoire",
    "validation.trackCountRequired": "Au moins 2 titres sont requis pour EP/Album",
    "validation.songwriterNameFormat": "Les auteurs doivent être au format Prénom Nom",
    "validation.contributorNameFormat": "Les contributeurs doivent être au format Prénom Nom",
    "validation.productionTeamNameFormat": "Les membres de l'équipe doivent être au format Prénom Nom",
    "releases.track": "Piste",
    
    // Toast Messages
    "toast.saveSuccess": "Enregistré avec succès",
    "toast.saveFailed": "Échec de l'enregistrement",
    "toast.deleteSuccess": "Supprimé avec succès",
    "toast.deleteFailed": "Échec de la suppression",
    "toast.uploadSuccess": "Téléchargé avec succès",
    "toast.uploadFailed": "Échec du téléchargement",
    "toast.submitSuccess": "Soumis avec succès",
    "toast.submitFailed": "Échec de la soumission",
    "toast.loginSuccess": "Connexion réussie",
    "toast.loginFailed": "Échec de connexion",
    "toast.logoutSuccess": "Déconnexion réussie",
    "toast.copySuccess": "Copié dans le presse-papiers",
    "toast.errorOccurred": "Une erreur s'est produite",
    "toast.pleaseFixErrors": "Veuillez corriger les erreurs dans cette section",
    
    // Spotify
    "spotify.title": "Spotify for Artists",
    "spotify.comingSoon": "Bientôt",
    "spotify.description": "Accédez à votre compte Spotify Artist directement depuis le panel EAM.",
};

export default fr;
